import o from "classnames";
import e from "react";
const w = "_stickyDrawer_j9q24_1", k = {
  stickyDrawer: w
}, { forwardRef: n } = e, f = n(({ children: r, className: t, dataTestId: s, open: a = !1, transition: i, zIndex: c, ...d }, y) => /* @__PURE__ */ e.createElement(
  "div",
  {
    ref: y,
    "aria-hidden": a ? void 0 : !0,
    className: o(k.stickyDrawer, "fuse-sticky-drawer", t),
    "data-testid": s || "fuse-sticky-drawer-test-id",
    ...d,
    style: {
      "--sticky-drawer-transition": i,
      "--sticky-drawer-z-index": c
    }
  },
  r
));
f.displayName = "StickyDrawer";
export {
  f as StickyDrawer
};
